import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNextBtnIcon = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "7px",
	height: "11px",
	viewBox: "0 0 7 11",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-678.000000, -720.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(659.000000, 707.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					transform: "translate(12.000000, 8.000000)",
					children: [
						/* @__PURE__ */ _jsx("mask", {
							id: "mask-ajo23dfs",
							fill: "white",
							children: /* @__PURE__ */ _jsx("polygon", { points: "7.15833333 14.45 10.975 10.625 7.15833333 6.8 8.33333333 5.625 13.3333333 10.625 8.33333333 15.625" })
						}),
						/* @__PURE__ */ _jsx("g", { fillRule: "nonzero" }),
						/* @__PURE__ */ _jsx("g", {
							mask: "url(#mask-ajo23dfs)",
							fill: "#FFFFFF",
							children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 20,
								height: 20
							}) })
						})
					]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgNextBtnIcon);
export { ForwardRef as ReactComponent };
